import api from '../../../config';

const path = 'v1/assets-infrastruktur/typ';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
